import type { Cache, UpdatesConfig, Variables } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { PolicyImportFileCreateMutation } from '@/components/FileImport/hooks/policyImportFileCreateMutation';

const fileImportMutations: UpdatesConfig['Mutation'] = {
  policyImportFileCreate: (
    data: PolicyImportFileCreateMutation,
    __: Variables,
    cache: Cache,
  ) => {
    if (data.policyImportFileCreate) {
      invalidateQuery('policyImportFiles', cache);
    }
  },
};

export default fileImportMutations;
